import React from 'react'
import SALink from 'components/SALink'
import { PROCESS_DATA, CAPABILITIES } from '../../helpers/constants'
import { updateTradeUrl } from '../../helpers/url'
type Props = {
  section: string
}

const Component = ({ section }: Props): React.ReactElement<React.ComponentProps<any>, any> => {
  const handleClick = (event: React.SyntheticEvent<Record<string, any>>) => {
    event.preventDefault()
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
    updateTradeUrl(`/trade/${CAPABILITIES}`, CAPABILITIES)
  }

  return (
    <div
      data-section='process'
      {...(section === CAPABILITIES
        ? {
            'data-style': 'capability',
          }
        : {})}
    >
      <p data-type='subtitle'>Our Process</p>
      <p data-type='description'>
        Our services range from design and concepting, to fabrication process development and final
        product installation.
      </p>
      <div data-type='item-row'>
        {PROCESS_DATA.map(({ title, image }) => (
          <div data-type='item'>
            <p>{title}</p>
            <picture data-type='image'>
              <img
                width='400'
                height='250'
                itemProp='image'
                className='lazyload'
                data-src={image}
                alt='process'
                role='presentation'
                data-type='image'
              />
            </picture>
          </div>
        ))}
      </div>
      {section !== CAPABILITIES ? (
        <SALink
          href='/trade/capabilities'
          data-type='explore-capabilities-link'
          onClick={handleClick}
        >
          Explore Our Capabilities
        </SALink>
      ) : (
        ''
      )}
    </div>
  )
}

export default Component